import { hotRankIds, getArticleById, type MelonArticle } from '@/mocks/melons';

function rankColor(i: number) {
  if (i === 1) return 'text-primary-600';
  if (i === 2) return 'text-accent-700';
  if (i === 3) return 'text-secondary-600';
  return 'text-foreground-300';
}

function pad(n: number) {
  return String(n).padStart(2, '0');
}

export default function HotRank() {
  const first = getArticleById(hotRankIds[0].id);
  const rest: { a: MelonArticle; rank: number }[] = hotRankIds
    .slice(1)
    .map((h) => ({ a: getArticleById(h.id)!, rank: h.rank }))
    .filter((x) => !!x.a);

  return (
    <section id="hot" className="scroll-mt-20 border-b border-background-200 bg-background-100 py-12 md:py-16">
      <div className="container-page">
        <div className="flex flex-col gap-3">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium tracking-wide text-primary-700">
            <i className="ri-fire-fill text-accent-500" aria-hidden="true" />
            Hot Ranking · 实时更新
          </span>
          <div className="flex flex-wrap items-end justify-between gap-3">
            <h2 className="text-2xl font-bold text-foreground-950 md:text-[34px]">
              今日热榜<span className="ml-2 text-primary-600">TOP 8</span>
            </h2>
            <a href="#collections" className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 hover:text-primary-800">
              查看更多瓜田盘点
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {first && (
            <a
              href={`/post/${first.id}`}
              className="group relative col-span-1 overflow-hidden rounded-2xl border border-background-200 bg-background-50 lg:col-span-5"
            >
              <div className="relative overflow-hidden">
                <img
                  src={first.image}
                  alt={first.title}
                  className="h-56 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 md:h-72"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" aria-hidden="true" />
                <span className="absolute left-4 top-4 font-heading text-6xl font-black text-background-50/90 md:text-7xl">
                  {pad(first.heat >= 10000 ? 1 : hotRankIds[0].rank)}
                </span>
                <span className="absolute bottom-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/90 px-3 py-1 text-xs font-bold text-primary-700 backdrop-blur">
                  <i className="ri-award-line" aria-hidden="true" />
                  今日 No.1
                </span>
              </div>
              <div className="p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="rounded-full bg-primary-100 px-2.5 py-0.5 font-semibold text-primary-700">{first.categoryName}</span>
                  <span>围观 {first.viewsText}</span>
                  <span>·</span>
                  <span>{first.time}</span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-xl">
                  {first.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{first.summary}</p>
              </div>
            </a>
          )}

          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:col-span-7 lg:grid-cols-1">
            {rest.map(({ a, rank }) => (
              <a
                key={a.id}
                href={`/post/${a.id}`}
                className="group flex items-center gap-4 rounded-xl border border-transparent bg-background-50 px-4 py-3.5 transition-colors hover:border-background-200 hover:bg-background-50"
              >
                <span className={`w-7 shrink-0 text-center font-heading text-2xl font-black ${rankColor(rank)}`}>{pad(rank)}</span>
                <span className="hidden shrink-0 rounded-full bg-background-100 px-2.5 py-1 text-xs font-semibold text-foreground-600 sm:inline">
                  {a.categoryName}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="line-clamp-1 block text-[15px] font-semibold text-foreground-900 transition-colors group-hover:text-primary-700">
                    {a.title}
                  </span>
                  <span className="mt-0.5 block text-xs text-foreground-500">
                    {a.host} · {a.heatLabel} 热度
                  </span>
                </span>
                <span className="flex items-center gap-1 text-xs text-accent-700">
                  <i className="ri-fire-line" aria-hidden="true" />
                  {a.heat >= 9000 ? '爆' : '热'}
                </span>
                <i className="ri-arrow-right-s-line text-lg text-foreground-300 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-500" aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}